<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="400"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        x-small
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Join Date"
      text="Update join date"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-menu
                v-model="joinDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="joindDateDisplay"
                    v-validate="'required'"
                    outlined
                    readonly
                    label="Join Date"
                    :error-messages="errors.collect('joindDateDisplay')"
                    data-vv-name="joindDateDisplay"    
                    data-vv-as="join date"
                    :class="{
                      'required':!joindDateDisplay
                    }"
                    class="label-position" 
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-calendar
                      </v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="localJoinDate"
                  :max="today"
                  @input="joinDateMenu = false"
                />
              </v-menu>
            </v-col>
          </v-row>
        </v-container>
      </form> 

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"      
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions> 
    </material-card>  
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      joinDate: {
        type: String,
        required: true,
      },
      confirmDate: {
        type: String,
        default: null,
        required: false,
      },      
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        localJoinDate: null,
        localConfirmDate: null,
        loading: false,
        joinDateMenu: false,
        today: new Date().toISOString().slice(0, 10), 
      }
    },
    computed: {
      joindDateDisplay () {
        return this.localJoinDate ? this.$moment(this.localJoinDate, 'YYYY-MM-DD').format('DD-MM-YYYY') : ''
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return

        this.loading = true

        this.localJoinDate = this.joinDate
        this.localConfirmDate = this.confirmDate

        this.loading = false
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            this.$api.jobDetails().update(this.employeeUid, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: 'Employee join date updated' })

                  this.setProgressing(false)
                  this.dialog = false
                }
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          joined_date: this.localJoinDate,
          confirm_date: this.localConfirmDate ? this.localConfirmDate : null,
        }
      },
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background: white;
}
</style>
